import { DEPLOYMENT_ENV, SENTRY_DSN } from '@/constant';
import * as Sentry from '@sentry/react';

const allowedUrlsRegExp =
  /^https?:\/\/(.*e-learning-mba.globis.co.jp|localhost:[0-9]+)/i;

export const startSentryTrackingError = () => {
  if (SENTRY_DSN) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: DEPLOYMENT_ENV,
      allowUrls: [allowedUrlsRegExp],
    });
  }
};
